import { HttpClient, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericApiService } from '@pm-ui/core-services';
import { Observable } from 'rxjs';
import { SiteEndpoints } from '../../config/sites/sites-end-point';
import { ISiteMasterVM } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class SitesService {

  constructor(private genericApiService: GenericApiService,private _http: HttpClient) { }


  getSites<T>(reqModel:any): Observable<any>{
    return this.genericApiService.post(SiteEndpoints.GetSites, reqModel);
 }

 getSiteById<T>(id: number): Observable<HttpResponse<T>> {
  return this.genericApiService.get<T>(`${SiteEndpoints.GetSiteById}/${id}`);
}

addSite<T>(model: ISiteMasterVM): Observable<HttpResponse<T>> {
  return this.genericApiService.post(SiteEndpoints.SaveSite, model);
}

updateSite<T>(model: ISiteMasterVM): Observable<HttpResponse<T>> {
  return this.genericApiService.post(SiteEndpoints.UpdateSite, model);
}

deleteSite<T>(SiteId: number): Observable<HttpResponse<T>> {
  return this.genericApiService.delete(`${SiteEndpoints.DeleteSite}/${SiteId}`);
}

checkInactiveSite<T>(SiteId: number): Observable<HttpResponse<T>> {
  return this.genericApiService.delete(`${SiteEndpoints.CheckInactiveSite}/${SiteId}`);
}

getState<T>(): Observable<any>{
  return this.genericApiService.get(SiteEndpoints.GetState);
}

getCityById<T>(id: number): Observable<HttpResponse<T>> {
  return this.genericApiService.get<T>(`${SiteEndpoints.GetCityById}/${id}`);
}

getCity<T>(): Observable<any>{
  return this.genericApiService.get(SiteEndpoints.GetCity);
}

uploadDocument<T>(formData: FormData): Observable<T> {
  return this.genericApiService
      .uploadImage<T>(`${SiteEndpoints.SaveSite}`, formData);
}

getUserSite<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetUserSites, reqModel);
}

GetTaskRaisedCategory<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetTasksRaisedCategory, reqModel);
}

GetTaskRaisedBuilding<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetTasksRaisedBuilding, reqModel);
}

ExpenditureReportCategory<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.ExpenditureReportCategory, reqModel);
}
ExpenditureReportBuilding<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.ExpenditureReportBuilding, reqModel);
}

TaskDaysOpen<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.TaskDaysOpens, reqModel);
}

GetExpCategoryBuildings<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetExpCategoryBuildings, reqModel);
}

getBuilding<T>(siteId: any,BuildingId:number): Observable<any>{
  return this.genericApiService.get<T>(`${SiteEndpoints.GetBuilding}/${siteId}/${BuildingId}`);
}

GetBuildingBySiteIdNonCapex<T>(siteId: any,BuildingId:number): Observable<any>{
  return this.genericApiService.get<T>(`${SiteEndpoints.GetBuildingBySiteIdNonCapex}/${siteId}/${BuildingId}`);
}

getPrioritySiteData<T>(reqModel: any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetPrioritySiteData, reqModel);
}

getStatusSiteData<T>(reqModel: any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetStatusSiteData, reqModel);
}

GetActiveTaskByProgress<T>(reqModel: any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetActiveTaskByProgress, reqModel);
}

GetActiveTaskByPriority<T>(reqModel: any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetActiveTaskByPriority, reqModel);
}
GetWorkOrderReportMonth<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetWorkOrderReportByMonth, reqModel);
}

GetPurchaseOrderReportMonth<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetPurchaseOrderReportByMonth, reqModel);
}


GetJobsheetSubmittedPerMonth<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetJobsheetSubmittedPerMonth, reqModel);
}

GetJobHoursPerTechnician<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetJobHoursPerTechnician, reqModel);
}

GetExpenditureReportCategoryNonCapex<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetExpenditureReportCategoryNonCapex, reqModel);
}
GetExpenditureReportCategoryNonCapexRecuring<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetExpenditureReportCategoryNonCapexRecuring, reqModel);
}

GetExpenditureReportBuildingNonCapex<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetExpenditureReportBuildingNonCapex, reqModel);
}
GetExpenditureReportBuildingNonCapexNonRecurring<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetExpenditureReportBuildingNonCapexNonRecurring, reqModel);
}
GetExpenditureReportBuildingNonCapexRecurring<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetExpenditureReportBuildingNonCapexRecurring, reqModel);
}


GetExpenditureReportCategoryBuildingNonCapex<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetExpenditureReportCategoryBuildingNonCapex, reqModel);
}
GetTechnicianJobHoursData<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetTechnicianJobHoursData, reqModel);
}
GetAllSiteData<T>(){
  return this.genericApiService.get(SiteEndpoints.GetAllSiteData);
}
GetTechnicianJobsheetSubmittedPerMonth<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetTechnicianJobsheetSubmittedPerMonth, reqModel);
}
GetExpenditurerReportoFNonCapexAndUnscheduled<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetExpenditurerReportoFNonCapexAndUnscheduled, reqModel);
}
GetExpenditurerReportoNonCapexAndScheduled<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetExpenditurerReportoNonCapexAndScheduled, reqModel);
}

getDueTaskByOwner<T>(reqModel: any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetDueTaskByOwner, reqModel);
}
GetActiveTaskByProgressByOwner<T>(reqModel: any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetActiveTaskByProgressByOwner, reqModel);
}

GetJobsheetHoursMaterialCostNonRecurring<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetJobsheetHoursMaterialCostNonRecurringByCategory, reqModel);
}

GetJobsheetHoursRecurringByCategory<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetjobSheetHoursAndMaterialsRecurring, reqModel);
}

GetJobSheetHoursByBuildingRecurring<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetJobSheetHoursByBuildingRecurring, reqModel);
}
GetJobSheetHoursByCategoryBuildingNonRecurring<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetJobSheetHoursByCategoryBuildingNonRecurring, reqModel);
}
GetJobSheetHoursByBuildingNonRecurring<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetJobSheetHoursByBuildingNonRecurring, reqModel);
}
GetJobSheetHoursByCategoryBuildingRecurring<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetJobSheetHoursByCategoryBuildingRecurring, reqModel);
}
GetMaterialsCostByCategoryRecurring<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetMaterialsCostByCategoryRecurring, reqModel);
}
GetMaterialsCostByCategoryNonRecurring<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetMaterialsCostByCategoryNonRecurring, reqModel);
}
GetMaterialsCostByBuildingNonRecurring<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetMaterialsCostByBuildingNonRecurring, reqModel);
}
GetMaterialsCostByBuildingRecurring<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetMaterialsCostByBuildingRecurring, reqModel);
}

GetMaterialsCostByCategoryBuildingNonRecurring<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetMaterialsCostByCategoryBuildingNonRecurring, reqModel);
}
GetMaterialsCostByCategoryBuildingRecurring<T>(reqModel:any): Observable<any>{
  return this.genericApiService.post(SiteEndpoints.GetMaterialsCostByCategoryBuildingRecurring, reqModel);
}

getUserSiteAuthorities(userId: number) {
  return this.genericApiService.get(`api/Sites/GetUserSiteAuthorities/${userId}`);
}

}
